import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import {verificaCache} from '../../../verificaCache';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';



class ListaDependentes extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: 'LISTAGEM',
      apiPage: null,
      data: 'loading',
      showTable: false,
      showColBroker: false,
      showColSalesman: false,
      showColStage: false,
      disabledInput: true,
      disabledInputValuePlan: true,

      tablePageStart: '',
      tablePageEnd: '',
      tablePageTotal: '',
    };

    this.errorField = {
      
    };

    this.errorFormat = {
      
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      inputSearch: {
        marginLeft: 8,
        flex: 1,
      },
      theadTh:{
        height: 40,
      },
      tdDate: {
        color: 'rgb(117, 117, 117)',
        margin: 0,
        fontSize: 11,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        lineHeight: '13px',
        letterSpacing: '0.33px',
        textTransform: 'uppercase',
        padding: 0,
        height: 40,
      }
    }

  }


  componentDidMount() {
    verificaCache(function (vc) {
      if (vc.erro === false) {
        if (configBase.moduloDependentes === true)
          this.getData(true);
        else {
          let state = this.state;
          state.data = 'error';
          this.setState(state);
        }
      }
      else
        this.setError(vc.mensagem);
    }.bind(this));
  }

  getData(table=false) {
    let url = configBase.api + 'Sales/dataDashboard?access_token='+localStorage.getItem('planos_t');
    let dataSubmit = {
      userId: localStorage.getItem('planos_u'),
      content: 'dependents'
    };

    axios.post(url, dataSubmit)
    .then((response) => {
      console.log(response.data);
      let state = this.state;

      if (response.data.dependentsData.length === 0) {
        state.data = 'zero';
      }
      else {
        this.setColorStatus(response.data.dependentsData);

        if (table === true && state.showTable === false) {
          state.showTable = true;
  
          $(document).ready( function () {
            let table = $('#table_id').DataTable({
              "dom": 'rtip',// Exibe {processing}{table}{information}{pagination}
              "language": {
                "url": `${process.env.PUBLIC_URL}/plugins/datatables/Portuguese-Brasil.lang`
              },
              "order": [[3, "desc"]],
              columnDefs: [
                { type: 'date-uk', targets: 3 },
              ],
              "infoCallback": function( settings, start, end, max, total, pre ) {// Quantidade por página
                document.getElementById('tablePageStart').innerHTML = start;
                document.getElementById('tablePageEnd').innerHTML = end;
                document.getElementById('tablePageTotal').innerHTML = total;
                return '';
              },
              pagingType: "simple",
              oLanguage: {
                oPaginate: {
                  sNext: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path></svg>',
                  sPrevious: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>'
                },
              },
              "scrollX": true,
            });
  
            $('#mySearchText').on( 'keyup', function () {
              table.search($('#mySearchText').val()).draw();
            } );
  
            // Quantidade por página
            $('#myLengthMenu').on( 'change', function () {
              table.page.len($('#myLengthMenu').val()).draw();
            } );
  
            $.extend( $.fn.dataTableExt.oSort, {
              "date-uk-pre": function ( a ) {
                if (a === null || a === "") {
                  return 0;
                }
                var ukDatea = a.split('/');
                return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
              },
            
              "date-uk-asc": function ( a, b ) {
                return ((a < b) ? -1 : ((a > b) ? 1 : 0));
              },
            
              "date-uk-desc": function ( a, b ) {
                return ((a < b) ? 1 : ((a > b) ? -1 : 0));
              }
            } );
          });
        }
      }

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));

  }

  setColorStatus(proposals) {
    let colors = {
      'atualizado': {color: configBase.bgImplementadas, name: 'ENVIADO'},
      'pendente': {color: configBase.bgCanceladas, name: 'PENDENTE'},
    };

    let state = this.state;

    for (let i = 0; i < proposals.length; i++) {
      if (proposals[i].enviado === undefined) {
        proposals[i].color = colors.pendente.color;
        proposals[i].status = colors.pendente.name;
      }
      else {
        proposals[i].color = colors[proposals[i].enviado].color;
        proposals[i].status = colors[proposals[i].enviado].name;
      }
    }

    state.data = proposals;
  }

  setMascCpf(cpf) {
    if (cpf) {
      cpf = cpf.replace(/\D/g,"");
      cpf = cpf.replace(/(\d{3})(\d)/,"$1.$2");
      cpf = cpf.replace(/(\d{3})(\d)/,"$1.$2");
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
    }

    return cpf;
  }

  sendDetails(financialManagerId) {
    this.props.history.push(`${process.env.PUBLIC_URL}/resumodependentes?dp=${financialManagerId}`);
  }

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="listaPropostas" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              {this.state.titlePage}
            </Typography>
          </Paper>

          <div id="listaPropostaConteudo" className="contentepanel">
          {
          this.state.data === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO LISTAGEM...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.data === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  {
                    configBase.moduloDependentes === false ? (
                  <Alert severity="error">Módulo de Gestão de Dependentes não habilitado. Entre em contato com a Intelite Tecnologia</Alert>
                    ) : (
                  <Alert severity="error">Problema ao buscar lista</Alert>
                    )
                  }
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.data === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem dependetes cadastrados</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="listaPropostaTabela">
              {/* ############# CSS PARA DATATABLE ############# */}
              <link
                rel="stylesheet" type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
              />
              <link
                rel="stylesheet" type="text/css"
                href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
              />
              {/* ############# CSS PARA DATATABLE ############# */}

              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} style={{marginBottom: 20}}>
                  <Paper elevation={1}>
                    <IconButton style={{padding: '6px 5px'}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      id="mySearchText"
                      style={this.styles.inputSearch}
                      placeholder="Pesquisar"
                      inputProps={{ 'aria-label': 'search google maps' }}
                    />
                  </Paper>
                </Grid>
              </Grid>

              <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                  <tr style={this.styles.theadTr}>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        TITULAR
                      </Typography>
                    </th>

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        CPF
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        E-MAIL
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        CADASTRO
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        ENVIO
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                      >
                        Status
                      </Typography>
                    </th>
                  </tr>
                </thead>

                <tbody>
                {this.state.data.map((item, index) =>
                  <tr
                    id={'row_sales_'+item.salesId}
                    key={index}
                    className="row_table"
                    onClick={this.sendDetails.bind(this, item.id)}
                    style={{cursor:'pointer', height: 40, padding: 0}}
                  >
                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {item.titular}
                      </Typography>
                    </td>

                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {this.setMascCpf(item.cpf)}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {item.email}
                      </Typography>
                    </td>
                    <td style={this.styles.tdDate}>
                      {moment(item.created).format('DD/MM/YYYY')}
                    </td>

                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        {
                          item.dataEnvio ? (
                            item.dataEnvio.split(' ')[0]
                          ) : ('-----')
                        }
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 11}}
                      >
                        <span
                          style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}
                        >
                          {item.status}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                )}
                </tbody>
              </table>

              <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                  <label htmlFor="myLengthMenu">Linhas por página: </label>
                  <select id="myLengthMenu" style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    {/* <option value="-1">Todas</option> */}
                  </select>
                  <span id="tablePageStart" style={{marginLeft: 15}}></span>-<span id="tablePageEnd"></span>
                  {' '}de{' '}
                  <span id="tablePageTotal"></span>
                </div>
              </div>

            </div>
              )
              )
            )
          }
          </div>
        </div>
      </MainLayout>
    );

  }

}

ListaDependentes.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaDependentes);